module.exports = {
    id: 'ops.portal.pioneerrx',
    name: 'Ops Portal',
    version: require('./package.json').version,
    context: {
        portalID: 'e98239f6-d299-482a-80ad-a09ee3082eb9',
        reCaptchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
    },
	brand: {
		title: 'PioneerRx Ops',
        companyName: 'PioneerRx',
        legalCompanyName: 'PioneerRx, LLC',
        logo: {
            default: '/assets/images/logo-pioneerrx.svg',
            light: '/assets/images/logo-pioneerrx-white.svg'
        },
        theme: 'light'
	},
	routing: {
		mode: 'history' // ["hash"|"history"]
	},
	api: {
        baseURL: process.env.API_BASEURL,
        oauthCallback: process.env.OAUTH_CALLBACK,
		legal: {
			privacyPolicy: `legal/privacypolicy?termsLink=${process.env.BASEURL}/legal/terms-of-use&privacyLink=${process.env.BASEURL}/legal/privacy-policy`,
			termsOfUse: `legal/termsofuse?termsLink=${process.env.BASEURL}/legal/terms-of-use&privacyLink=${process.env.BASEURL}/legal/privacy-policy`
		}
	},
	auth: {
		allowPersistentSessions: true,
        client: 'ops',
        keycloakURL: process.env.KEYCLOAK_URL,
        realm: 'PioneerRx',
        refreshThreshold: 90
    },
    dashboards: {
        editDataSourcePermissions: [],
        locationsEnabled: false,
        templatesEnabled: false
    },
    logging: {
        ajax: false,
        mutations: false
    },
	env: {
        mode: process.env.NODE_ENV,
        testing: process.env.TESTING,
		production: process.env.PRODUCTION
	}
};
